import { gql } from 'apollo-boost';

export const CURRICULUM_QUERY = gql`
  query curriculum($curriculumId: UUID!, $brandId: UUID) {
    curriculum(curriculumID: $curriculumId) {
      node {
        id
        locales {
          locale
          name
          description
        }
        heroImage {
          id
          url
        }
        thumbnailImage {
          id
          url
        }
        prerequisiteSet {
          operator
          prerequisites {
            objectId
          }
        }
        tags
        courses(useSegmentationFilter: false) {
          totalCount
          edges {
            enrollment {
              status
              rating
              review
              userCertificate(brandId: $brandId) {
                id
                userCertificateUrl
              }
            }
            node {
              id
              courseCertificates {
                id
                brand {
                  id
                  name
                }
              }
              tags
              locales {
                locale
                name
                description
              }
              thumbnailImage {
                id
                url
              }
              learningObjects {
                totalCount
                edges {
                  assignment {
                    status
                  }
                  node {
                    id
                    content {
                      id
                      mimetype
                    }
                  }
                }
              }
              localeIds
              learningProfileIds
              brandIds
              companyRelationshipIds
              productIds
              categoryIds
              metadata
            }
          }
        }
        localeIds
        learningProfileIds
        resourceIds
        companyRelationshipIds
        productIds
        brandIds
        categoryIds
        metadata
      }
    }
  }
`;
